import type { SVGProps } from 'react';
const SvgImageAspectRatio = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#image_aspect_ratio_svg__a)">
      <path
        fill="currentColor"
        d="M16 10h-2v2h2v-2Zm0 4h-2v2h2v-2Zm-8-4H6v2h2v-2Zm4 0h-2v2h2v-2Zm8-6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2Zm0 14H4V6h16v12Z"
      />
    </g>
    <defs>
      <clipPath id="image_aspect_ratio_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgImageAspectRatio;
